import {get as _get} from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';
import initialState from '../initialstate';
import {
	ADD_ALL_POTENTIAL_CONTACTS_TO_ADD,
	ADD_POTENTIAL_CONTACT,
	GET_POTENTIAL_CONTACTS_TO_ADD,
	GET_POTENTIAL_CONTACTS_TO_REMOVE,
	IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD,
	IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE,
	IGNORE_POTENTIAL_CONTACT_TO_ADD,
	IGNORE_POTENTIAL_CONTACT_TO_REMOVE,
	REMOVE_POTENTIAL_CONTACT,
	UPDATE_PROJECT
} from '../../actions/actiontypes';
import normalizeAccessLogData from './normalizeAccessLogData';
import normalizeRemovePotentialContact from './normalizeRemovePotentialContact';

export function contactDBAccessLog(state = initialState.contactsAccessLog, action) {
	switch (action.type) {
		case GET_POTENTIAL_CONTACTS_TO_ADD: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				const orgChart = _get(action, 'orgChart', []);
				return {...state, contactsToAdd: normalizeAccessLogData(data, orgChart)};
			}
			return {...state, contactsToAdd: []};
		}

		case GET_POTENTIAL_CONTACTS_TO_REMOVE: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				const orgChart = _get(action, 'orgChart', []);
				return {...state, contactsToRemove: normalizeAccessLogData(data, orgChart)};
			}
			return {...state, contactsToRemove: []};
		}

		case IGNORE_POTENTIAL_CONTACT_TO_ADD:
		case IGNORE_POTENTIAL_CONTACT_TO_REMOVE:
		case ADD_POTENTIAL_CONTACT:
		case REMOVE_POTENTIAL_CONTACT: {
			const status = _get(action, 'responseObj.status', null);
			const contactId = _get(action, 'contactId', null);
			const entityId = _get(action, 'entityId', null);
			if (status === HttpStatusCodes.Created) {
				if (action.type === IGNORE_POTENTIAL_CONTACT_TO_ADD || action.type === ADD_POTENTIAL_CONTACT) {
					return {...state, contactsToAdd: normalizeRemovePotentialContact(state.contactsToAdd, entityId, contactId)};
				}
				if (action.type === IGNORE_POTENTIAL_CONTACT_TO_REMOVE || action.type === REMOVE_POTENTIAL_CONTACT) {
					return {
						...state,
						contactsToRemove: normalizeRemovePotentialContact(state.contactsToRemove, entityId, contactId)
					};
				}
				return {...state};
			}
			if (status === HttpStatusCodes.NoContent) {
				if (action.type === IGNORE_POTENTIAL_CONTACT_TO_REMOVE || action.type === REMOVE_POTENTIAL_CONTACT) {
					return {
						...state,
						contactsToRemove: normalizeRemovePotentialContact(state.contactsToRemove, entityId, contactId)
					};
				}
				return {...state};
			}
			return {...state};
		}

		case IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD:
		case IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE:
		case ADD_ALL_POTENTIAL_CONTACTS_TO_ADD: {
			const status = _get(action, 'responseObj.status', null);
			const entityId = _get(action, 'entityId', null);
			if (status === HttpStatusCodes.Created) {
				if (action.type === IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD || action.type === ADD_ALL_POTENTIAL_CONTACTS_TO_ADD)
					return {...state, contactsToAdd: normalizeRemovePotentialContact(state.contactsToAdd, entityId)};
			}
			if (status === HttpStatusCodes.NoContent) {
				if (action.type === IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE)
					return {...state, contactsToRemove: normalizeRemovePotentialContact(state.contactsToRemove, entityId)};
				return {...state};
			}
			return {...state};
		}

		case UPDATE_PROJECT: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				if (state?.contactsToAdd !== null) {
					return {...state, contactsToAdd: null};
				}
			}
			return state;
		}

		default: {
			return state;
		}
	}
}
